import {getLoanStatusTextByValue} from "../loanUtility";
import {getFormatTextByValue} from "../../../Order/orderUtility";

export const loanHistory = ({
                                barCode,
                                copy,
                                copyId,
                                dateCheckedOut,
                                dateCheckedOutFormatted,
                                dateDue,
                                dateOrderSentToVendor,
                                dateOrderSentToVendorFormatted,
                                dateReturned,
                                dateReturnedFormatted,
                                fimcStaffId,
                                id,
                                isbn,
                                loanStatus,
                                needFrom,
                                needTo,
                                order,
                                orderId,
                                patron,
                                patronId,
                                patronName,
                                queueItemId,
                                shippingLocation,
                                shippingLocationId,
                                shippingLocationName,
                                student,
                                studentId,
                                studentName,
                                title,
                            }: Record<string, any> = {}) => ({
    barCode,
    copy,
    copyId,
    dateCheckedOut,
    dateCheckedOutFormatted,
    dateDue,
    dateOrderSentToVendor,
    dateOrderSentToVendorFormatted,
    dateReturned,
    dateReturnedFormatted,
    fimcStaffId,
    format: getFormatTextByValue(copy?.catalogFormat?.format),
    id,
    isbn,
    loanStatus: loanStatus || 0,
    loanStatusText: getLoanStatusTextByValue(loanStatus || 0),
    needFrom,
    needTo,
    order,
    orderId,
    patron,
    patronId,
    patronName,
    queueItemId,
    shippingLocation,
    shippingLocationId,
    shippingLocationName,
    student,
    studentId,
    studentName,
    title,
});

